import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { IDeviceTeleopConfiguration } from "@formant/core/model/IDeviceTeleopConfiguration";
import { rtcAgentInfoStreamType } from "@formant/core/model/rtcStreamTypes";
import { IRtcStreamMessage } from "@formant/rtc-client/models/IRtcStreamMessage";
import { Fader } from "@formant/ui/component/common/Fader";

import { operateStore } from "../../stores";
import { Switch } from "../common/Switch";
import * as styles from "./TeleopLowBandwidthModeSwitch.scss";

export interface ILowBandwidthModeSwitchProps {
    configuration?: IDeviceTeleopConfiguration;
}

@observer
export class TeleopLowBandwidthModeSwitch extends Component<ILowBandwidthModeSwitchProps> {
    @observable
    private lowBandwidthModeEnabled = false;
    @observable
    private disabled = true;

    private unregister?: () => void;
    public componentDidMount() {
        const { session } = operateStore;
        if (!session) {
            return;
        }
        this.unregister = session.registerReceiver(
            `$.${rtcAgentInfoStreamType}`,
            this.onReceiveAgentInfo,
        );
    }
    public componentWillUnmount() {
        this.unregister?.();
    }
    public render() {
        const { lowBandwidthModeEnabled, disabled } = this;
        const { configuration } = this.props;
        const { allowLowBandwidthMode } = operateStore;
        if (!configuration) {
            return false;
        }

        return (
            <Fader
                visible={allowLowBandwidthMode}
                className={styles["teleop-low-bandwidth-mode-switch"]}
                onClick={this.onToggle}
            >
                <div className={styles.label}>Low Bandwidth</div>
                <Switch
                    className={styles.switch}
                    state={lowBandwidthModeEnabled}
                    disabled={disabled}
                />
            </Fader>
        );
    }

    private onToggle = () => {
        if (this.disabled) {
            return;
        }
        const { session } = operateStore;
        this.lowBandwidthModeEnabled = !this.lowBandwidthModeEnabled;
        this.disabled = true;
        session?.setLowBandwidthMode(this.lowBandwidthModeEnabled);
    };

    private onReceiveAgentInfo = (message: IRtcStreamMessage) => {
        const { isLowBandwidthMode } = message.payload.agentInfo ?? {};
        if (isLowBandwidthMode !== undefined) {
            this.lowBandwidthModeEnabled = isLowBandwidthMode;
            this.disabled = false;
        }
    };
}
